(function($) {
    const Tab = {
        init: function (){
            $(document).on('click', '[data-sc-toggle="tab"]', (event) => this.activate(event.currentTarget));
            this.activateCurrentModel($(document));
        },

        activateCurrentModel(context) {
            const $scope = context ? $(context) : $(document);

            const $activeModel = $('.models [data-post-id].active');
            
            if ($activeModel.length) {
                const activePostId = $activeModel.data('post-id');
                if (activePostId) {
                    $scope.find(`.sc-tab-link[data-sc-target*="-${activePostId}-"]`).each(function() {
                        Tab.activate(this);
                    });
                    return;
                }
            }

            // Fallback: activar el primer tab interno de cada grupo dentro del contexto
            $scope.find('.sc-tab-container').each(function() {
                const $firstTab = $(this).find('[data-sc-toggle="tab"]').first();
                if ($firstTab.length) {
                    Tab.activate($firstTab[0]);
                }
            });
        },

        activate(element) {
            const $elementClick = $(element);
            const targetSelectorTabs = $elementClick.data('sc-parent');
            const $containerTabs = $(targetSelectorTabs);
            const targetSelector = $elementClick.data("sc-target");
            const $allTabs = $containerTabs.find('[data-sc-toggle="tab"]');

            $allTabs.removeClass("active").each(function () {
                const associatedPanel = $(this).data("sc-target");
                $(associatedPanel).removeClass("active");
                $(this).find('.sc-tab').removeClass("active");
            });

            const $tab = $containerTabs.find(`[data-sc-target="${targetSelector}"]`);
            $tab.addClass("active").find('.sc-tab').addClass("active");
            $(targetSelector).addClass("active");

            const isMainTab = $containerTabs.is('#wc-product-tabs');
            if (isMainTab) {
                Tab.activateCurrentModel($(targetSelector));
            }
        },
    }
    Tab.init();
})(window.jQuery);